export default __webpack_public_path__ + "static/media/20s_popup_bg@2x.7934ffcd.png";